<template>
  <div
    v-if="filters.length"
    :class="classOverride"
  >
    <!-- <v-tabs
      v-model="activeTab"
      grow
      color="secondary"
      selected-class="tab-active"
    >
      <v-tab
        v-if="!tabsEnabled || tabsEnabled.includes('basic')"
        value="basic"
      >
        <v-icon>mdi-select-search</v-icon>
        <span
          v-if="!$device.isMobile"
          class="ml-3"
        >Recherche</span>
      </v-tab>
      <v-tab
        v-if="(!tabsEnabled || tabsEnabled.includes('advance')) && $permissionCheck(`${permissionName}_advanced_search`)"
        value="advance"
      >
        <v-icon>mdi-database-search</v-icon>
        <span
          v-if="!$device.isMobile"
          class="ml-3"
        >Recherche avancée</span>
      </v-tab>
      <v-tab
        v-if="!tabsEnabled || tabsEnabled.includes('custom')"
        value="custom"
      >
        <v-icon>mdi-text-search</v-icon>
        <span
          v-if="!$device.isMobile"
          class="ml-3"
        >Recherche pré-enregistrée</span>
      </v-tab>
    </v-tabs> -->
    <v-card class="py-2 px-5">
      <v-window
        v-model="activeTab"
        disabled
      >
        <v-window-item value="basic">
          <v-form ref="filters" validate-on="submit lazy" @submit.prevent="$emit('resetPagination'); $emit('loadData');">

              <ListFiltersBasic
                ref="basic"
                :loading
                :filters-overload
                :filters
                :translation-name
                @reset-pagination="$emit('resetPagination')"
                @load-data="$emit('loadData')"
              />

                      <!-- https://vuetifyjs.com/en/api/v-expansion-panel-title/ -->
           <!-- IF MOREFILTEROVERLOAD IS IN FILTERS : SHOW PANEL (Handle filters missing because of permissions) -->
          <v-row v-if="this.filters.map(filter => filter.name).some(name => this.moreFiltersOverload.includes(name))">
            <v-col
              cols="12"
              :md="moreOptionsPanel ? 12 : 6"
              :lg="moreOptionsPanel ? 12 : 3"
            >
              <v-expansion-panels
                v-if="moreFiltersOverload?.length"
                multiple
                class="more-options-filters pa-2"
                @update:model-value="moreOptionsPanel = !moreOptionsPanel"
              >
                <v-expansion-panel elevation="0">
                  <v-expansion-panel-title
                    class="py-0"
                    :ripple="true"
                  >
                    {{ moreOptionsPanel ? "Cacher les filtres" : "Voir plus de filtres" }}
                  </v-expansion-panel-title>
                  <div
                    v-show="moreOptionsPanel"
                    class="py-2 more-filters"
                  >
                    <ListFiltersBasic 
                      ref="moreFilters"
                      :loading
                      :filters-overload="moreFiltersOverload"
                      :filters
                      :translation-name
                      @reset-pagination="$emit('resetPagination')"
                      @load-data="$emit('loadData')"
                    />
                  </div>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

          <ListFiltersActions
            :loading
            @reset-filters="resetFiltersInit()"
            @reset-pagination="$emit('resetPagination')"
            @load-data="$emit('loadData')"
          />
        </v-form>

        </v-window-item>
        <!-- <v-window-item value="advance">
          <InfoCard text="En cours de développement" />
        </v-window-item>
        <v-window-item value="custom">
          <InfoCard text="En cours de développement" />
        </v-window-item>
      </v-window> -->
      </v-window>
    </v-card>
  </div>
</template>
<script lang="ts">
export default {
    name : "FiltersComponent",
    props: {
        permissionName: { type: String, required: true },
        translationName: { type: String, required: true },
        tabsEnabled: { type: Array, required: false, default: () => [] },
        filters: { type: Array, required: true },
        loading: { type: Boolean, required: false },
        filtersOverload: { type: Array, required: false, default: () => [] },
        moreFiltersOverload: { type: Array, required: false, default: () => [] },
        classOverride : { type : String, required : false, default: 'mb-10 filters' },
    },
    emits: ['resetPagination', 'loadData'],
    data () {
        return {
            activeTab : 'basic',
            moreOptionsPanel: false,
            localLoading: false,
        }
    },
    computed : {
        query () { // COMPUTED NEEDED TO REFRESH EXPORTS BUTTONS
            return this.getQuery()
        },
    },
    watch: {
      loading() {
        this.localLoading = false
      }
    },
    methods : {
      getQuery () { // METHODS NEEDED CAUSE COMPUTED DOESNT ALWAYS REFRESH ON PARENT'S METHOD.
          const basic = this.$refs.basic?.query || {}
          const moreFilters = this.$refs.moreFilters?.query || {}
          return {...moreFilters, ...basic};
      },
      resetFiltersInit() {
        this.$refs.filters.reset()
        this.$refs?.basic?.resetFilters()
        this.$refs?.moreFilters?.resetFilters()

        this.$emit('resetPagination')
        this.$emit('loadData')
      },
    }
}
</script>
